import { render, staticRenderFns } from "./Facturas.vue?vue&type=template&id=9a977e1a&"
import script from "./Facturas.vue?vue&type=script&lang=js&"
export * from "./Facturas.vue?vue&type=script&lang=js&"
import style0 from "./Facturas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports